const AGENCY_TAG_TYPES = {
  AGENCY_GET_LIST: "AGENCY_LIST",
  AGENCY_CREATE: "AGENCY_CREATE",
  AGENCY_EDIT: "AGENCY_EDIT",
  AGENCY_DETAIL: "AGENCY_DETAIL",
  CURRENT_USER: "CURRENT_USER"
};

export const AGENCY_TAGS = Object.values(AGENCY_TAG_TYPES);
export default AGENCY_TAG_TYPES;
